const IMAGE_TYPE = new Set([
  "tiff",
  "apng",
  "bmp",
  "gif",
  "ico",
  "cur",
  "jpg",
  "jpeg",
  "jfif",
  "pjpeg",
  "pjp",
  "png",
  "svg",
  "webp",
]);

export function getDocumentExtension(documentUrl: string): string {
  try {
    const documentUrlSplit = documentUrl.split(".");
    return documentUrlSplit.at(-1)!.split("?")[0];
  } catch {
    return "";
  }
}

export function isImageType(documentUrl: string): boolean {
  return IMAGE_TYPE.has(getDocumentExtension(documentUrl).toLowerCase());
}

export const msWordTypes = {
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
} as const;

export function ismsWordMimeTypes(mimeType: string) {
  // eslint-disable-next-line unicorn/prefer-includes
  return Object.values(msWordTypes).some((type) => type === mimeType);
}

export function ismsWordTypes(documentUrl: string): boolean {
  // eslint-disable-next-line unicorn/prefer-includes
  return Object.keys(msWordTypes).some(
    (type) => type === getDocumentExtension(documentUrl).toLowerCase()
  );
}
